export default {
  setupPhotoCover: "تنصيب صورة الواجهة",
  description: "الصوره على الاقل يجب ان اتكون  4KB",
  error: "نوع الملف غير مدعوم ...",
  uploadImage: "رفع الصورة",
  cancel: "الغاء",
  submit: "رفع",
};
